<template>
	<div class="modal fade" id="createTaskModal" role="dialog" aria-labelledby="updateLabel" aria-hidden="true">
		<div class="modal-dialog" role="document" data-backdrop="static">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="updateLabel">Task</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="loader" v-if="isSaving"></div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12 form-group">
							<span class="h5">{{model.title}}</span>
						</div>
						<div class="col-md-12 form-group">
							<label>{{$t('tasks.status')}}</label>
							<DynamicDropdown v-model="model.statusId" :fieldName="$t('tasks.status')" :items="statuses" :api-url="'/api/Dropdown/TaskStatuses'"></DynamicDropdown>
						</div>
						<div class="col-md-12 form-group" v-if="model.statusId == 4">
							<label>{{$t('tasks.timeToFinish')}}</label>
							<input type="text" class="form-control" v-model="model.timeToFinish" />
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-primary">Accept</button>
					<button type="button" class="btn btn-secondary" data-dismiss="modal">Refuse</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Task } from '../../models/models';
import DynamicDropdown from '../dropdown/DynamicDropdown';

export default {
	components: {
		DynamicDropdown
	},
	props: {
		value: {
			type: Object,
			required: false
		},
		show: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			model: {},
			isSaving: false,
			statuses: []
		};
	},
	methods: {
		onSave(e) {
			e.preventDefault();

			this.$validator.validate().then(valid => {
				if (valid) {
					this.save();
				}
			});
		},
		save() {
			this.isSaving = true;
			const model = {
				id: this.model.id,
				statusId: this.model.statusId,
				timeToFinish: this.model.timeToFinish
			};

			this.$http
				.put('/api/tasks/update', model)
				.then(result => {
					this.$vs.notify({
						color: 'success',
						title: this.$t('updateSuccess'),
						text: ''
					});
					this.$emit('updated', model);
				})
				.catch(err => {
					this.$vs.notify({
						color: 'danger',
						title: this.$t('notifications.error'),
						text: this.$t('notifications.serverError')
					});
				})
				.then(() => {
					this.hide();
				});
		},
		onClose() {
			this.$emit('onClose', { ...this.model });
			this.model = new Task();
			this.isSaving = false;
			this.$validator.reset();
		},
		hide() {
			$(this.$el).modal('hide');
		}
	},
	mounted() {
		// add modal close listener
		$(this.$el).on('hidden.bs.modal', this.onClose);
	},
	beforeDestroy() {
		// remove listener
		$(this.$el).off('hidden.bs.modal');
	},
	watch: {
		show: function(val) {
			if (val) {
				let { id, statusId, timeToFinish } = this.value;
				this.model = {
					id,
					statusId,
					timeToFinish
				};
				$(this.$el).modal('show');
			} else {
				$(this.$el).modal('hide');
			}
		}
	}
};
</script>

<style>
</style>
